import React, {useEffect} from 'react';
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import HideAppBar from "../../widgets/header/HideAppBar";
import {Container, Paper} from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import clsx from "clsx";
import axios from "axios";
import moment from "moment";


const GestioneEts = () => {
	const classes = BaseStyle();
	
	const download = async () => {
		const req = await axios({
			method: "get",
			url: `/atlantis-api-v1/API/ets/download`,
			responseType: "blob",
		});
		let blob = new Blob([req.data], {
			type: req.headers["content-type"],
		});
		const link = document.createElement("a");
		link.href = window.URL.createObjectURL(blob);
		link.download = `ticket_albo_ets_${moment(new Date()).format("DD_MM_YYYY__HH_mm")}.xlsx`;
		link.click();
	}
	
	useEffect(() => {
		document.body.style = `background: none;`;
	}, []);
	
	return (
		<React.Fragment>
			<main className={classes.main}>
				<HideAppBar title={"Carico dati"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Paper className={clsx(classes.roundPaper, classes.padding2)}>
								<Typography>
									Per scaricare il file degli ETS cliccare sul seguente bottone:<br/>
								</Typography>
								<Typography color={"textSecondary"} component={"div"}>
									Attendi qualche istante e vedrai comparire nella sezione download del tuo browser un file con nome:
									"ticket_albo_ets_" seguito dalla data ed ora del download.<br/>
									In caso di problematiche nello scarico del file ti invito a riprovare almeno due o tre volte per
									assicurarti che non vi siano problemi di connessione; in caso contario contatta tempestivamente gli
									sviluppatori di Ocean scrivendo una mail a:<br/>
									<ul>
										<li><a href={"mailto:assistenza.ocean@aslcittaditorino.it"}>assistenza.ocean@aslcittaditorino.it</a>
										</li>
										<li><a href={"mailto:enrico.arnaudo@aslcittaditorino.it"}>Enrico</a></li>
										<li><a href={"mailto:micheleluigi.greco@aslcittaditorino.it"}>Michele</a></li>
									</ul>
								</Typography>
								<Button className={classes.roundButton} style={{borderRadius: 24, margin: 10}} variant={"contained"}
								        color={"primary"} disableElevation
								        onClick={download}>
									<b>Scarica file</b>
								</Button>
							</Paper>
						</Grid>
					</Grid>
				</Container>
			</main>
		</React.Fragment>
	);
};

export default React.memo(GestioneEts)
